<template>
  <b-modal id="file-manager-modal" size="lg" title="Файлы" v-model="showModal" hide-footer ok-variant="outline-primary">
    <b-form @submit.prevent="onUpload" :disabled="uploadForm.processing">
      <b-form-row align-h="between">
        <div class="col-10">
          <b-file v-model="uploadForm.file" accept="image/*" browse-text="Выбрать" placeholder="Файл не выбран"></b-file>
        </div>
        <div class="col">
          <b-btn type="submit" variant="outline-primary" block>Загрузить</b-btn>
        </div>
      </b-form-row>
      <b-img v-if="hasImage" :src="imgSrc" class="mt-3 mb-3" thumbnail fluid block></b-img>
    </b-form>
    <br>
    <b-card-group columns>
      <b-card overlay text-variant="white" :img-src="fileUrl" v-for="(fileUrl, index) in files" :key="index+fileUrl">
        <b-card-text>
          <b-btn-group size="sm" vertical>
            <b-btn @click="onDelete(fileUrl)">
              <font-awesome-icon icon="trash" />
            </b-btn>
            <b-btn @click="onSelect(fileUrl)">
              <font-awesome-icon icon="paste"/>
            </b-btn>
          </b-btn-group>
        </b-card-text>
      </b-card>
    </b-card-group>
  </b-modal>
</template>

<script>
const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(data)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

export default {
  name: 'FileManager',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    type: {
      type: String,
      required: true,
      default: 'image',
      validator (value) {
        return ['image', 'file'].indexOf(value) !== -1
      }
    }
  },
  mounted () {
    this.loadFiles()
  },
  data () {
    return {
      showModal: this.show,
      uploadForm: this.$inertia.form({
        file: null
      }),
      imgSrc: null,
      files: []
    }
  },
  methods: {
    onUpload () {
      const data = new FormData()
      data.append('file', this.uploadForm.file)

      window.axios
        .post(
          this.route('backend.file-manager.upload'),
          data,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
        .then(resp => {
          if (resp.data.status === 'OK') {
            this.uploadForm.reset()
            this.loadFiles()
          }
        })
    },

    onDelete (path) {
      if (!confirm('Вы уверены?')) {
        return
      }

      window.axios
        .delete(
          this.route('backend.file-manager.destroy'),
          { data: { path } }
        )
        .then(resp => {
          if (resp.data.status === 'OK') {
            this.loadFiles()
          }
        })
    },

    onSelect (path) {
      this.$emit('select', path)
      this.$bvModal.hide('file-manager-modal')
    },

    loadFiles () {
      window.axios.get(this.route('backend.file-manager.index')).then(resp => {
        this.files = resp.data.files
      })
    }
  },
  computed: {
    hasImage () {
      return !!this.uploadForm.file
    }
  },
  watch: {
    'uploadForm.file' (newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.imgSrc = value
            })
            .catch(() => {
              this.imgSrc = null
            })
        } else {
          this.imgSrc = null
        }
      }
    },

    show (value) {
      this.showModal = value
    },

    showModal (value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style scoped>
</style>
